import { types } from 'mobx-state-tree';

import HttpErrorResponse from 'js/stores/types/HttpErrorResponse';
import { reportClientError } from 'js/services/Network';
import AppState from 'js/stores/AppState';
import AppUser from 'js/stores/AppUser';

export default types
  .model('PageState', {
    isBooting: true,
    error: types.maybeNull(HttpErrorResponse),
  })
  .actions(self => ({
    bootPage(bootstrap) {
      self.isBooting = true;
      if (typeof bootstrap === 'function') {
        const bootstrapResult = bootstrap();
        if (bootstrapResult && typeof bootstrapResult.then === 'function') {
          return bootstrapResult.then(self.bootSuccess).catch(self.bootError);
        } else {
          return Promise.resolve(self.bootSuccess());
        }
      } else {
        return Promise.resolve(self.bootSuccess());
      }
    },
    bootSuccess() {
      self.isBooting = false;
      return true;
    },
    bootError(error) {
      self.isBooting = false;
      if (error.response) {
        self.error = {
          status: error.response.status,
          error: error.response.data.message,
        };
      } else if (typeof error === 'string') {
        self.error = {
          status: 'SORRY',
          error,
        };
      } else if (error.status) {
        self.error = error;
      } else {
        if (['production', 'staging'].includes(window.app.env)) {
          reportClientError({
            error: error.message,
            page: AppState.currentPage,
            user_email: AppUser.email,
          });
        } else {
          console.error(error);
        }
        self.error = {
          status: 'INTERNAL',
          error: error.message,
        };
      }
    },
  }));
